import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { createHigherOrderComponent } from '@wordpress/compose';
import  { InspectorControls } from '@wordpress/block-editor';
import  { PanelBody, TextControl, Flex } from '@wordpress/components';


const allowedBlocks = [ 'core/cover', 'core/image' ];

const addInspectorControl = createHigherOrderComponent( ( BlockEdit ) => {
	return (props) => {

		if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

		const {		
			attributes, setAttributes, isSelected,
		} = props;

		const {
			url, id, alt
		} = attributes;

		const onSelectURL = ( newURL ) => {
			setAttributes( { url: newURL,	id: undefined,	alt: '' } );
		};
	

		return (
			<>
				<BlockEdit {...props} />
				<InspectorControls>
					<div className='sidebar-wrapper'> 			
						<TextControl
							label={ __( 'Image Link', 'aver' ) }
							value={ url }
							onChange={ onSelectURL }					
						/>
					</div>
				
				</InspectorControls>
			</>
		);
	};
}, 'withInspectorControl');

addFilter(
	'editor.BlockEdit',
	'aver/image-cover-advanced-control',
	addInspectorControl,
);



